import { useLocale, useTranslations } from 'next-intl';

import './payment-badges.css';

/**
 * "iyzico ile Öde" + kart markaları — ödemenin kimin altyapısıyla ve hangi
 * kartlarla alındığını gösteren şerit.
 *
 * ---------------------------------------------------------------------------
 * Neden var (14 Eki 2026)
 * ---------------------------------------------------------------------------
 * iyzico'nun üye iş yeri incelemesi sitede "iyzico ile Öde" logosunu ve
 * Visa/MasterCard logolarını istiyor. İki yerde basılıyor: her herkese açık
 * sayfanın footer'ı ve paneldeki ödeme ekranı (kart formunun altı).
 *
 * ---------------------------------------------------------------------------
 * Varlıklar iyzico'nun resmî paketinden, svgl'den DEĞİL
 * ---------------------------------------------------------------------------
 * `https://cdn.iyzipay.com/merchant-panel/files/iyzico-logo-pack.zip` →
 * `public/logos/payments/`:
 *
 *   • `iyzico-ile-ode.svg`  — paketin `Tr_Colored_Horizontal`ı, olduğu gibi
 *   • `pay-with-iyzico.svg` — paketin `En_Colored_horizontal`ı, olduğu gibi
 *   • `card-brands.svg`     — paketin footer bandından (`logo_band_colored`)
 *                             YALNIZ `viewBox` kırpılarak çıkarıldı (x 125'ten):
 *                             Mastercard · Visa · American Express · Troy.
 *                             Yol silinmedi, renk değişmedi.
 *
 * Bandın kendisi iki satırlı "iyzico / ile Öde" işaretiyle geliyor ve
 * İngilizcesi yok. İşaret dile göre seçilsin diye bant ikiye bölündü: işaret
 * dilin yatay logosu, kartlar ortak. `public/logos/cards/` altındaki tek tek
 * kart logoları (kart önizlemesi kullanıyor) burada KULLANILMADI — dördünün
 * optik boyu farklı ve iyzico'nun bandı onları zaten dengelenmiş veriyor.
 *
 * Türkçe dışındaki 12 dil İngilizce işareti alıyor: iyzico'nun paketinde
 * yalnız iki dil var.
 *
 * ---------------------------------------------------------------------------
 * Zemin
 * ---------------------------------------------------------------------------
 * Renkli sürümler beyaz zemin için. Şerit bugün yalnız beyaz yüzeylerde
 * duruyor (footer `#fff`, ödeme paneli kart zemini). Koyu bir yüzeye
 * konacaksa paketin `White` sürümleri eklenmeli — renkli olan orada kaybolur.
 *
 * Tıklanabilir DEĞİL: iyzico'ya bağlantı istenmiyor ve hareketi olan tek
 * şey girişi — onu çağıran yüzey veriyor (footer'da `sceneItem`).
 */

const MARK = {
  tr: { src: '/logos/payments/iyzico-ile-ode.svg', width: 210, height: 31 },
  en: { src: '/logos/payments/pay-with-iyzico.svg', width: 210, height: 29 },
} as const;

export function PaymentBadges({
  size = 'md',
  className,
}: {
  /** `sm` ödeme panelinin dar sütunu için; `md` footer. */
  size?: 'sm' | 'md';
  className?: string;
}) {
  const t = useTranslations('paymentBadges');
  const locale = useLocale();
  const mark = locale === 'tr' ? MARK.tr : MARK.en;

  return (
    <div
      className={className ? `pay-badges ${className}` : 'pay-badges'}
      data-size={size}
      role="group"
      aria-label={t('label')}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- statik SVG, optimize edilecek bir şey yok */}
      <img
        className="pay-badges-mark"
        src={mark.src}
        width={mark.width}
        height={mark.height}
        alt={t('mark')}
        loading="lazy"
        decoding="async"
      />
      {/* eslint-disable-next-line @next/next/no-img-element -- statik SVG */}
      <img
        className="pay-badges-cards"
        src="/logos/payments/card-brands.svg"
        width={304}
        height={32}
        alt={t('cards')}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
